import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PersonFormModel } from '@shared/models/forms/person-form.model';
import { BrokernetLanguageType, Gender } from '@backend/models';
import { DateValidator } from '../validators/date.validator';

export function createPersonForm(): FormGroup<PersonFormModel> {
  return new FormGroup<PersonFormModel>({
    id: new FormControl<string | null>(null),
    titlePrefix: new FormControl<string | null>(null),
    firstname: new FormControl<string | null>(null, [Validators.required]),
    lastname: new FormControl<string | null>(null, [Validators.required]),
    titleSuffix: new FormControl<string | null>(null),
    gender: new FormControl<Gender | null>(null, [Validators.required]),
    birthdate: new FormControl<string | null>(null, [DateValidator.maxDate(new Date()), Validators.required]),
    //TODO: find out how to set the language. Use a dropdown or use the website's language?
    language: new FormControl<BrokernetLanguageType | null>(BrokernetLanguageType.De, [Validators.required]),
    email: new FormControl<string | null>(null, [Validators.email, Validators.required]),
    phone: new FormControl<string | null>(null, [Validators.required])
  });
}

